import React from 'react';
import { useSmartGoBack } from '@hooks/use-smart-go-back';

import { NavigationBackButtonProps } from './navigation-back-button.type';

export const NavigationBackButton = ({
  children,
  className = '',
  defaultRoute,
  forceDefaultRoute,
}: NavigationBackButtonProps) => {
  const { smartGoBack } = useSmartGoBack();

  const navigateToPrevious = () => {
    smartGoBack(defaultRoute, forceDefaultRoute);
  };

  return (
    <button className={className} type='button' aria-label='Menu' onClick={navigateToPrevious}>
      {children}
    </button>
  );
};
